import { render } from "./CompleteConfirmationDialog.vue?vue&type=template&id=09c12a0c&scoped=true"
import script from "./CompleteConfirmationDialog.vue?vue&type=script&lang=ts"
export * from "./CompleteConfirmationDialog.vue?vue&type=script&lang=ts"

import "./CompleteConfirmationDialog.vue?vue&type=style&index=0&id=09c12a0c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-09c12a0c"

export default script